module.exports = __webpack_public_path__ + "img/public/SiteIcons/fb.svg?d1340261";